"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
const filter_context_1 = require("./filter_context");
const context_1 = require("../../context");
const react_1 = require("react");
const core_1 = require("@apitable/core");
const react_2 = __importDefault(require("react"));
const filter_base_1 = require("./filter_base");
const react_redux_1 = require("react-redux");
const store_1 = require("../../store");
const Filter = props => {
    const { widgetStore } = (0, react_1.useContext)(context_1.WidgetContext);
    const { datasheetId, onChange } = props;
    const snapshot = (0, react_redux_1.useSelector)(state => (0, store_1.getSnapshot)(state, datasheetId));
    if (!snapshot) {
        return react_2.default.createElement(react_2.default.Fragment, null, `${datasheetId} datasheet is loading`);
    }
    const expressFilter = (0, core_1.parseFilterExpressByOpenFilter)(props.filter || {}, {
        fieldMap: snapshot.meta.fieldMap,
        state: widgetStore.getState()
    }) || undefined;
    (0, core_1.injectStore)(widgetStore);
    return (react_2.default.createElement(filter_context_1.FilterContext.Provider, { value: {
            store: widgetStore
        } },
        react_2.default.createElement(filter_base_1.FilterBase, Object.assign({}, props, { filter: expressFilter === null || expressFilter === void 0 ? void 0 : expressFilter.value, onChange: (value) => {
                const filter = (0, core_1.parseOpenFilterByExpress)(value, {
                    meta: snapshot.meta,
                    state: widgetStore.getState()
                });
                onChange && onChange(filter);
            } }))));
};
exports.Filter = Filter;
